module.exports = __webpack_public_path__ + "static/media/talk2x.68c9e74d.png";